module.exports = __webpack_public_path__ + "img/JCU.3b5942a8.png";